import { render, staticRenderFns } from "./TestActionButtons.vue?vue&type=template&id=6abcb676&scoped=true&"
import script from "./TestActionButtons.vue?vue&type=script&lang=js&"
export * from "./TestActionButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6abcb676",
  null
  
)

export default component.exports